import { STATIC_MEDIA_URL } from '@wix/image-kit'
import type { ImagePlaceholder, IImagePlaceholderService, IImagePlaceholderConfig } from './types'

export const createPlaceholderGetter = (
	getWOWPlaceholder: any,
	{
		baseMediaUrl = STATIC_MEDIA_URL,
		isSEOBot = false,
		userDomainMediaBaseUrl,
		userDomainMediaPrefixes = [],
	}: IImagePlaceholderConfig
): IImagePlaceholderService => {
	const SCHEME_RE = /^[a-z]+:/

	return {
		getPlaceholder: ({ fittingType, src, target, options }) => {
			const placeholder = getWOWPlaceholder(fittingType, src, target, {
				...(options || {}),
				isSEOBot,
				autoEncode: true,
			})

			const srcUri = src.uri ?? (src as any).id
			const isUserMedia =
				srcUri && userDomainMediaBaseUrl && userDomainMediaPrefixes.some((p) => srcUri.startsWith(`${p}_`))
			const effectiveBase = (isUserMedia ? userDomainMediaBaseUrl! : baseMediaUrl).replace(/\/$/, '')

			if (placeholder && placeholder.uri && !SCHEME_RE.test(placeholder.uri)) {
				placeholder.uri = `${effectiveBase}/${placeholder.uri}`
			}

			if (placeholder?.srcset?.dpr) {
				placeholder.srcset.dpr = placeholder.srcset.dpr.map((s: string) =>
					SCHEME_RE.test(s) ? s : `${effectiveBase}/${s}`
				)
			}

			return placeholder as ImagePlaceholder
		},
	}
}
